import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  dialogRef!: MatDialogRef<DialogComponent>;
  constructor(
    private dialog: MatDialog
  ) { }

  /**
   * ダイアログを開く
   * confirmTextがない場合、アラートとして使う
   */
  public open(options: { title: any; message: any; cancelText: any; confirmText?: any; showInput?: boolean; }, disableClose: boolean = false) {
    this.dialogRef = this.dialog.open(DialogComponent, {
      data: {
        title: options.title,
        message: options.message,
        cancelText: options.cancelText,
        confirmText: options.confirmText,
        showInput: options.showInput
      }
    });
    this.dialogRef.disableClose = disableClose;
  }

  /**
   * Inputで入力した値を取得する
   */
  public getInputValue(): any {
    return this.dialogRef.componentInstance.formControl.value;
  }

  public setInputValue(value: string) {
    this.dialogRef.componentInstance.formControl.setValue(value);
  }

  /**
   * 確認ボタンを押下後のイベント
   */
  public confirmed(): Observable<any> {

    return this.dialogRef.afterClosed().pipe(take(1), map((res: any) => {
      return res;
    }
    ));
  }

}
